import axios from "axios";

const clientAPI = url =>
  axios.create({
    maxRedirects: 1,
    baseURL: url,
    withCredentials: false
  });
export default clientAPI;
